import Alert from "@/components/common/Alert.vue"
import XButton from "./components/common/XButton.vue"
import Carousel from "./components/common/Carousel.vue"
import CopyToClipboard from "@/components/common/CopyToClipboard.vue"
import Flag from "./components/common/Flag.vue"
import XInput from "./components/common/XInput.vue"
import MultiSelect from "./components/common/MultiSelect.vue"
import QuickActionsMenu from "./components/common/QuickActionsMenu.vue"
import QuickActionsMenuItem from "./components/common/QuickActionsMenuItem.vue"
import XTable from "@/components/common/XTable.vue"
import Tag from "@/components/common/Tag.vue"
import XTextArea from "./components/common/XTextArea.vue"
import CampaignStatus from "@/components/common/CampaignStatus.vue"
import Image from "@/components/common/Image.vue"
import Widget from "./components/common/Widget.vue"
import SectionHeader from "@/components/common/SectionHeader.vue"
import MiniSection from "@/components/common/MiniSection.vue"
import ConnectedFields from "@/components/common/ConnectedFields.vue"
import FloatingVue from "floating-vue"
import Vue3FormWizard from "vue3-form-wizard"
import { ModalsContainer } from "vue-final-modal"

// Import Global CSS
import "floating-vue/dist/style.css"
import "vue3-form-wizard/dist/style.css"

export function registerGlobalComponents(app) {
  app.component('Alert', Alert)
  app.component('XButton', XButton)
  app.component('Carousel', Carousel)
  app.component('CopyToClipboard', CopyToClipboard)
  app.component("Flag", Flag)
  app.component('XInput', XInput)
  app.component('MultiSelect', MultiSelect)
  app.component('QuickActionsMenu', QuickActionsMenu)
  app.component('QuickActionsMenuItem', QuickActionsMenuItem)
  app.component('XTable', XTable)
  app.component('Tag', Tag)
  app.component('XTextArea', XTextArea)
  app.component("CampaignStatus", CampaignStatus)
  app.component('Image', Image)
  app.component('Widget', Widget)
  app.component("SectionHeader", SectionHeader)
  app.component('MiniSection', MiniSection)
  app.component('ConnectedFields', ConnectedFields)
  app.use(FloatingVue)
  app.use(Vue3FormWizard)
  app.component("ModalsContainer", ModalsContainer)
}
